import React from 'react';
import { useParams } from 'react-router-dom';
import { useMcaPolling } from '../../../../../../utils/customHooks';
import FinancialMetrics from '../../../Overview/components/FinancialMetrics/FinancialMetrics';

interface FinancialSummaryTabProps {
    assesseeOrgId?: string;
    isPDFReport?: boolean;
}

const FinancialSummaryTab = ({ assesseeOrgId = '', isPDFReport }: FinancialSummaryTabProps) => {
    const queryParams = useParams();
    const orgId = queryParams.id || assesseeOrgId;
    const { mcaDocData } = useMcaPolling(orgId);
    return <FinancialMetrics screen="overview" assesseeOrgId={orgId} mcaDocApiData={mcaDocData} isPDFReport={isPDFReport} />;
};

export default FinancialSummaryTab;
